export enum CARD_VARIANTS {
  PRIMARY = 'PRIMARY',
  WARNING = 'WARNING',
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
  NEUTRAL = 'NEUTRAL',
  DISABLED = 'DISABLED',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
  /** Add more variants here as needed... */
}

export const CARD_PROGRESS_HEIGHT_OFFSET = 3;
